export default __webpack_public_path__ + "static/media/radiant-reversed.aced4ca3.svg";